export const CHECKOUT_URL = 'https://scuba-diving-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/9ijAUubKYmukRb2j25Wjmt/Kit_premium_para_instructores_de_buceo_(1).png'

export const HERO_IMAGE_ALT =
  'Scuba Diving Instructor Ready complete system: Class Finder tablet, 6 volumes, 150 ready-to-teach scuba lessons and 5 professional bonus guides'

export const PRIMARY_CTA = 'GET SCUBA DIVING INSTRUCTOR READY NOW'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Scuba Foundations, Equipment & First Lessons' },
  { kind: 'included', label: 'Volume 2 — Buoyancy, Breathing, Trim & Underwater Control' },
  { kind: 'included', label: 'Volume 3 — Descents, Ascents, Equalization & Controlled Water Skills' },
  { kind: 'included', label: 'Volume 4 — Mask, Regulator, Finning, Navigation & Buddy Skills' },
  { kind: 'included', label: 'Volume 5 — Safety, Problem Management & Underwater Decision-Making' },
  { kind: 'included', label: 'Volume 6 — 150 Ready-to-Teach Scuba Lessons — Beginner to Advanced' },
  { kind: 'bonus', label: 'Scuba Instructor Cueing & Error Correction Handbook' },
  { kind: 'bonus', label: '100 Scuba Training Drills, Skill Challenges & Student Practice Tasks' },
  { kind: 'bonus', label: 'Scuba Student Assessment & Progress Tracking System' },
  { kind: 'bonus', label: 'Scuba Lesson Planning & Skill Progression System' },
  { kind: 'bonus', label: 'Scuba Training Troubleshooting & Problem-Solving Manual' },
  { kind: 'included', label: '100% Visual Teaching Material' },
  { kind: 'included', label: 'Immediate Digital Access' },
]
